export default __webpack_public_path__ + "static/media/Logo_BS_Corporate_Quadri.156a1675.svg";